import React from "react";
import Modal from "../../../../../../_components/Modal";
import Button from "../../../../../../_components/Button";
import Text from "../../../../../../_components/Text";
import Toast from "../../../../../../_components/Toast";
import LoadingInput from "../../../../../../_components/LoadingInput";
import TableData from "../../../../../../_components/TableData";
import { createCCE, getCCeHistory } from "../../../../../../api/nfe";
import { donwloadBase64, showSnackBar } from "../../../../../../utils";
export default (props) => {
  const [loading, setLoading] = React.useState(false);
  const [toast, setToast] = React.useState({})
  const [show, setShow] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [x_just, setXJust] = React.useState("");

  function onCreate() {
    setToast({})
    setLoading(true);
    createCCE(props.nfe.id, { x_just })
      .then((resp) => {
        const { key, data } = resp;
        setToast({ message: "Carta de Correção emitida!", show: true })
        donwloadBase64(key, "pdf", "application/pdf", data);
        loadData();
        onHide()
      })
      .catch((resp) => {
        if (resp.data) {
          if (resp.data.plan_error) {
            setToast({ message: "Não foi possível emitir a CC-e: Sem notas disponíveis ou plano vencido!", show: true, type: "error" })
          }
          return;
        }
        if (resp.plan_permission_error) {
          setToast({ message: "Não foi possível emitir a CC-e: Seu plano exige uma nota adicional para essa operação", show: true, type: "error" })
          return
        }
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1500);
      });
  }
  function onShow() {
    setShow(true);
    loadData();
  }
  function onDownload(item, type) {
    donwloadBase64(item.key, type, `application/${type}`, item[`${type}64`]);
  }
  function loadData() {
    setLoading(true);
    getCCeHistory(props.nfe.id)
      .then((data) => {
        data = data.map((item) => {
          return {
            ...item,
            downloads: (
              <div>
                <Button
                  disabled={!item.pdf64}
                  as="text"
                  onClick={() => onDownload(item, "pdf")}
                >
                  <i className="fas fa-file-pdf text-danger mr-4" />
                </Button>
                <Button as="text" onClick={() => onDownload(item, "xml")}>
                  <i className="fas fa-file-code text-info" />
                </Button>
              </div>
            ),
          };
        });
        setData(data);
      })
      .catch((resp) => {
        if (resp.error) {
          showSnackBar(resp.error, "danger", 10000);
          return;
        }
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          try {
            document.querySelector('[name="cce-x-just"]').focus();
          } catch (error) { }
        }, 400);
      });
  }
  function onHide() {
    if (loading) {
      return;
    }
    setShow(false);
    setXJust("");
    setData([]);
  }

  return (
    <React.Fragment>
      <Button
        onClick={onShow}
        as="text"
        className="text-info mx-1"
        disabled={props.nfe.status != 1}
      >
        <i
          className="fas fa-file-signature"
          title="CC-e (Carta de correção eletrônica)"
        />
        <span>CC-e (Carta de correção eletrônica)</span>
      </Button>
      <Modal title="Carta de correção (CC-e) " show={show} onHide={onHide}>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <Text>Destinatário</Text>
              <Text>{props.nfe.recipient_name}</Text>
            </div>
            <div className="col-md-4">
              <Text>Número</Text>
              <Text>{props.nfe.number}</Text>
            </div>
            <div className="col-md-4">
              <Text>Série</Text>
              <Text>{props.nfe.series}</Text>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 my-3">
              <Text>Conteúdo da correção </Text>
              <LoadingInput
                value={x_just}
                name="cce-x-just"
                loading={loading}
                onChange={(e) => setXJust(e.target.value)}
                as="textarea"
                onKeyDown={(e) => {
                  if (e.key === ' ') {
                    setXJust(`${x_just} `)
                  }
                }}
              />
              <span
                className={
                  x_just.length < 15 ? "text-danger d-block" : "d-none"
                }
              >
                O conteúdo da correção precisa ter no mínimo 15 caracteres.
              </span>
            </div>
            <div className="col-md-12 my-3">
              <Button
                onClick={onCreate}
                disabled={loading || x_just.length < 15}
                as="text"
              >
                Enviar correção
              </Button>
            </div>
          </div>
          <div className="row my-3">
            <div className="col-md-12">
              <TableData
                data={data}
                tHead={["Descrição", "Seq.", "Arquivos"]}
                tBodyKeys={["description", "sequence", "downloads"]}
              />
            </div>
          </div>
        </div>
      </Modal>
      <Toast {...toast} />
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/Actions/CCe/index.jsx